import React from 'react';

interface UserProfileWarningProps {
  text: string;
}

export const UserProfileWarning = ({ text }: UserProfileWarningProps) =>
  <div className="main-grid">
    <div className="alert-warning mb-5">
      <p>{text}</p>
    </div>
  </div>;
